import React, { memo, useLayoutEffect } from 'react';
import { MAX_WIDGET_WIDTH } from '../constants/generic';
import { Themes, Theme, IThemeCustomization } from './types';
import { appendStyleToShadowRoot, generateAndAppendVariableStyles } from './_variables/general';
import TailwindLoader from './loader';

export interface IThemeProviderProps {
  children: React.ReactNode;
  dataTheme?: Themes;
  themes?: IThemeCustomization;
  shadow?: ShadowRoot | null;
  tailwindStyles: string;
  isLoading: boolean;
  refForShadow?: React.RefObject<HTMLDivElement>;
  withDatePickerStyles?: boolean;
  bgColor?: string;
}

function TailwindTheme({
  themes,
  dataTheme = Theme.light,
  children,
  shadow,
  isLoading,
  refForShadow,
  tailwindStyles,
  withDatePickerStyles = false,
  bgColor = 'auto',
}: IThemeProviderProps) {
  useLayoutEffect(() => {
    if (!shadow) return;

    // create tailwind styles
    appendStyleToShadowRoot(shadow, 'tailwind-styles', tailwindStyles);

    // generate variable styles
    generateAndAppendVariableStyles(shadow, dataTheme, themes, withDatePickerStyles);
  }, [shadow, tailwindStyles, dataTheme, themes, withDatePickerStyles]);

  return (
    <div
      ref={refForShadow}
      style={{ maxWidth: `${MAX_WIDGET_WIDTH}px`, backgroundColor: isLoading ? 'transparent' : bgColor, lineHeight: 1 }}
    >
      {isLoading ? <TailwindLoader /> : children}
    </div>
  );
}

export default memo(TailwindTheme);
